const icons = require.context('../packs/images', true);
const updates = require.context('../packs/images/update-icons', true);
const flags = require.context('../packs/images/flags', true);
const searchIcons = require.context('../packs/images/search', true);
const notificationIcons = require.context('../packs/images/notification', true);
const stateIcons = require.context('../packs/images/state', true);
const detailsIcons = require.context('../packs/images/details', true);
const panesIcons = require.context('../packs/images/panes', true);
const stateSmallIcons = require.context('../packs/images/state/small', true);
const costIcons = require.context('../packs/images/cost', true);
const markersIcons = require.context('../packs/images/markers', true);
const transitIcons = require.context('../packs/images/transit', true);
const metricsIcons = require.context('../packs/images/metrics', true);

export const getIcon = (icon, extension='svg') => {
  return icons(`./${icon}.${extension}`)
}

export const getUpdateIcon = (update) => {
  return updates(`./${update}.svg`)
}

export const getFlag = (flag) => {
  return flags(`./${flag}.png`)
}

export const getSearchIcon = (field) => {
  return searchIcons(`./${field}.svg`)
}

export const getNotificationIcon = (notification) => {
  return notificationIcons(`./${notification}.svg`)
}

export const getStateIcon = (state) => {
  return stateIcons(`./${state}.svg`)
}

export const getDetailsIcon = (details) => {
  return detailsIcons(`./${details}.svg`)
}

export const getPanesIcon = (panes) => {
  return panesIcons(`./${panes}.svg`)
}

export const getStateSmallIcon = (stateSmall) => {
  return stateSmallIcons(`./${stateSmall}.svg`)
}

export const getCostIcons = (cost) => {
  return costIcons(`./${cost}.svg`)
}

export const getMarkerIcons = (marker) => {
  return markersIcons(`./${marker}.svg`)
}

export const getTransitIcons = (transit) => {
  return transitIcons(`./${transit}.svg`)
}

export const getMetricsIcon = (metric) => {
  return metricsIcons(`./${metric}.svg`)
}
